import {MaterialType, MaterialTypeCode} from '@aviary/store/common/common.types';

export const FALLBACK_MATERIAL_TYPE: MaterialType = {
  code: MaterialTypeCode.UNKNOWN,
  name: '',
  description: ''
};
